/**
 * Null where the browser has no BroadcastChannel (Safari before 15.4) or creating one fails; the
 * caller then has no cross-tab sync.
 */
export const openBroadcastChannel = (name: string): BroadcastChannel | null => {
  if (IS_SSR) {
    return null;
  }
  if (typeof BroadcastChannel === 'undefined') {
    console.error(`Could not create BroadcastChannel "${name}": not supported by this browser`);
    return null;
  }
  try {
    return new BroadcastChannel(name);
  } catch (error) {
    console.error(`Could not create BroadcastChannel "${name}"`, error);
    return null;
  }
};
